import React from "react";
import { Link } from "react-router-dom";
import Carousel from "../components/Carousel";
import GrilleImages from "../components/GrilleImages";
import { Helmet } from "react-helmet";
import { useT } from "../hooks/useLang";

export default function Accueil() {
  const t = useT();
  return (
    
    <div className="min-h-screen" style={{ background: "var(--bg)" }}>
      <Helmet>
        <title>Starting Five - Accueil</title>
        <meta name="description" content="Starting Five, groupe togolais proposant des services innovants pour simplifier votre quotidien." />
      </Helmet>

      {/* Hero */}
      <div style={{ background: "var(--bg)", borderBottom: "4px solid var(--border)" }}
        className="pt-24 pb-14">
        <div className="max-w-5xl mx-auto px-6">
          <span className="eyebrow">{t("bienvenue")}</span>

          <h1 style={{
            fontFamily: "var(--font-display)",
            color: "#E0392B",
            fontSize: "clamp(2.5rem, 6vw, 4rem)",
            WebkitTextStroke: "2px var(--ink)",
            textShadow: "4px 4px 0 var(--ink)",
            lineHeight: 1.05,
            marginBottom: "1rem",
          }}>
            Starting Five
          </h1>

          <p className="text-lg font-medium mb-8"
            style={{ color: "var(--ink-soft)", maxWidth: 520 }}>
            Retrouvez toutes les informations sur nos services.
            L'excellence à votre service !
          </p>

          <div className="flex flex-wrap gap-4">
            <Link to="/nos-services" className="brut-btn"
              style={{
                background: "var(--accent)",
                color: "var(--ink)",
                border: "3px solid var(--border)",
                boxShadow: "var(--shadow-sm)",
              }}>
              NOS SERVICES →
            </Link>
            <Link to="/qui-sommes-nous" className="brut-btn brut-btn-white">
              QUI SOMMES-NOUS ?
            </Link>
          </div>
        </div>
      </div>

      {/* Bande déco */}
      <div className="section-band" />

      {/* Carrousel */}
      <div className="pt-0">
        <Carousel />
      </div>

      {/* ── Boutons services ── */}
      <div style={{ background: "var(--bg)", borderTop: "4px solid var(--border)", borderBottom: "4px solid var(--border)" }}
        className="py-8 px-6">
        <div style={{ maxWidth: 760, margin: "0 auto", display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center" }}>

          {/* ── Bouton Wash Bros ── */}
          <Link
            to="/wash-bros-teasing"
            style={{
              flex: "1 1 300px",
              maxWidth: 360,
              display: "flex",
              alignItems: "center",
              gap: 18,
              background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 60%, #bfdbfe 100%)",
              border: "3px solid #1e3a8a",
              borderRadius: 20,
              padding: "20px 24px",
              boxShadow: "6px 6px 0 #1e3a8a",
              position: "relative",
              overflow: "hidden",
              textDecoration: "none",
              transition: "transform 0.1s, box-shadow 0.1s",
            }}
            className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-xl transition-all group"
          >
            {[
              { w: 60, h: 60, top: -15, right: 20, opacity: 0.15 },
              { w: 30, h: 30, bottom: 8, right: 60, opacity: 0.12 },
              { w: 20, h: 20, top: 10, right: 80, opacity: 0.1 },
            ].map((b, i) => (
              <div key={i} style={{
                position: "absolute",
                width: b.w, height: b.h,
                top: b.top, right: b.right, bottom: b.bottom,
                borderRadius: "50%",
                background: "rgba(59,130,246,0.5)",
                opacity: b.opacity,
                pointerEvents: "none",
              }} />
            ))}

            <div>
              <div style={{
                fontWeight: 800,
                fontSize: "1.1rem",
                color: "#1e3a8a",
                fontFamily: "var(--font-display)",
                letterSpacing: "0.01em",
              }}>
                Wash Bros
              </div>
              <div style={{
                fontSize: "0.9rem",
                color: "#1e40af",
                fontWeight: 600,
                marginTop: 3,
              }}>
                Découvrir bientôt →
              </div>
            </div>
          </Link>

          {/* ── Bouton Café Zamenoulli ── */}
          <Link
            to="/zamenoulli-teasing"
            style={{
              flex: "1 1 300px",
              maxWidth: 360,
              display: "flex",
              alignItems: "center",
              gap: 18,
              background: "linear-gradient(135deg, #fdf6ec 0%, #fef9f0 60%, #f5deb3 100%)",
              border: "3px solid #78350f",
              borderRadius: 20,
              padding: "20px 24px",
              boxShadow: "6px 6px 0 #78350f",
              position: "relative",
              overflow: "hidden",
              textDecoration: "none",
              transition: "transform 0.1s, box-shadow 0.1s",
            }}
            className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-xl transition-all group"
          >
            {[
              { w: 60, h: 60, top: -15, right: 20, opacity: 0.15 },
              { w: 30, h: 30, bottom: 8, right: 60, opacity: 0.12 },
              { w: 20, h: 20, top: 10, right: 80, opacity: 0.1 },
            ].map((b, i) => (
              <div key={i} style={{
                position: "absolute",
                width: b.w, height: b.h,
                top: b.top, right: b.right, bottom: b.bottom,
                borderRadius: "50%",
                background: "rgba(120,53,15,0.4)",
                opacity: b.opacity,
                pointerEvents: "none",
              }} />
            ))}

            <div>
              <div style={{
                fontWeight: 800,
                fontSize: "1.1rem",
                color: "#78350f",
                fontFamily: "var(--font-display)",
                letterSpacing: "0.01em",
              }}>
                Zamenoulli
              </div>
              <div style={{
                fontSize: "0.9rem",
                color: "#92400e",
                fontWeight: 600,
                marginTop: 3,
              }}>
                Découvrir bientôt →
              </div>
            </div>
          </Link>

          {/* ── Bouton WhoWe ── */}
          <Link
            to="/whowe"
            style={{
              flex: "1 1 300px",
              maxWidth: 360,
              display: "flex",
              alignItems: "center",
              gap: 18,
              background: "linear-gradient(135deg, #dcfce7 0%, #f0fdf4 60%, #bbf7d0 100%)",
              border: "3px solid #15803d",
              borderRadius: 20,
              padding: "20px 24px",
              boxShadow: "6px 6px 0 #15803d",
              position: "relative",
              overflow: "hidden",
              textDecoration: "none",
              transition: "transform 0.1s, box-shadow 0.1s",
            }}
            className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-xl transition-all group"
          >
            {[
              { w: 60, h: 60, top: -15, right: 20, opacity: 0.15 },
              { w: 30, h: 30, bottom: 8, right: 60, opacity: 0.12 },
              { w: 20, h: 20, top: 10, right: 80, opacity: 0.1 },
            ].map((b, i) => (
              <div key={i} style={{
                position: "absolute",
                width: b.w, height: b.h,
                top: b.top, right: b.right, bottom: b.bottom,
                borderRadius: "50%",
                background: "rgba(34,197,94,0.5)",
                opacity: b.opacity,
                pointerEvents: "none",
              }} />
            ))}

            <div>
              <div style={{
                fontWeight: 800,
                fontSize: "1.1rem",
                color: "#15803d",
                fontFamily: "var(--font-display)",
                letterSpacing: "0.01em",
              }}>
                WhoWe
              </div>
              <div style={{
                fontSize: "0.9rem",
                color: "#16a34a",
                fontWeight: 600,
                marginTop: 3,
              }}>
                Découvrir bientôt →
              </div>
            </div>
          </Link>

        </div>
      </div>

      {/* Grille d'images */}
      <div style={{ borderTop: "4px solid var(--border)" }}>
        <GrilleImages />
      </div>

    </div>
  );
}